var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "skpfull_wrap", attrs: { id: "wrap" } }, [
    _c("div", { attrs: { id: "container" } }, [
      _c("div", { staticClass: "container_wrap" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.contentsView,
                expression: "contentsView"
              }
            ],
            attrs: { id: "contents" }
          },
          [
            _c("div", { staticClass: "contents_wrap" }, [
              _c("h2", { staticClass: "pg_title" }, [
                _vm._v(_vm._s(_vm.title))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "result_wrap" }, [
                _c("div", { staticClass: "youSelected_box" }, [
                  _c("article", { staticClass: "selectd_info" }, [
                    _c("dl", [
                      _c("dt", [
                        _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.MODEL.CODE")))
                      ]),
                      _vm._v(" "),
                      "" === _vm.request.NATION_NM
                        ? _c("dd", [_vm._v(_vm._s(_vm.request.MODEL_CD))])
                        : _c("dd", [
                            _vm._v(
                              _vm._s(_vm.request.MODEL_CD) +
                                "(" +
                                _vm._s(_vm.request.NATION_NM) +
                                ")"
                            )
                          ])
                    ]),
                    _vm._v(" "),
                    _c("dl", [
                      _c("dt", [
                        _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.PRODUCT.CATEGORY")))
                      ]),
                      _vm._v(" "),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.request.CATE_MAIN_NM) +
                            " / " +
                            _vm._s(_vm.request.CATE_SUB_NM)
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                "EE" === _vm.erpGroupCode
                  ? _c("div", [
                      _c("table", { staticClass: "data_table_ty2" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("thead", [
                          _c("tr", [
                            _c("th", [
                              _vm._v(_vm._s(_vm.$t("FIELD.SEARCH.MODELS")))
                            ]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.VERSION")))
                            ]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(_vm._s(_vm.$t("FIELD.SEARCH.PDF")))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          { staticClass: "text_center" },
                          _vm._l(_vm.result, function(item, idx) {
                            return _c(
                              "tr",
                              { key: item.BMODEL_ID + item.VERSION + idx },
                              [
                                _c("td", [_vm._v(_vm._s(item.BMODEL_ID))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(item.VERSION))]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  _vm._l(item.attach.rowData, function(
                                    file,
                                    idx
                                  ) {
                                    return _c(
                                      "a",
                                      {
                                        key: file.ATTCH_FILE_SEQ + idx,
                                        staticClass: "txt_link",
                                        attrs: {
                                          href: _vm.getDownloadUrl(
                                            file.ENC_ATTCH_FILE_SEQ,
                                            file.ENC_TOKEN
                                          ),
                                          download: "true",
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                                " +
                                            _vm._s(file.FILE_NM) +
                                            "\n                                            "
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    ])
                  : _c(
                      "div",
                      _vm._l(_vm.result, function(item, idx) {
                        return _c(
                          "section",
                          {
                            key: item.BMODEL_ID + item.VERSION + idx,
                            attrs: { "data-type": "quick" }
                          },
                          [
                            _c("div", { staticClass: "result_title" }, [
                              _c(
                                "em",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.constantSection($event)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(item.KNOWLEDGE_TITLE) +
                                      "\n                                        "
                                  ),
                                  _c("span", { staticClass: "item-date" }, [
                                    _vm._v("(" + _vm._s(item.MODF_DT) + ")")
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "result_con" }, [
                              _c("div", { staticClass: "view_desc" }, [
                                !(
                                  "This is CMS contents" ===
                                    item.KNOWLEDGE_DESC ||
                                  "" === item.KNOWLEDGE_DESC
                                )
                                  ? _c("div", { staticClass: "tab_wrap" }, [
                                      _c(
                                        "ul",
                                        {
                                          staticClass: "tab_menu_02 tab_menus"
                                        },
                                        [
                                          _c("li", { staticClass: "on" }, [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "javascript:" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "SUBTITLE.GLOBAL.DESCRIPTION"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "tab_contents" },
                                        [
                                          _c("div", {
                                            staticClass: "tab_cont",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.stripHtml(
                                                  item.KNOWLEDGE_DESC
                                                )
                                              )
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "text-align": "right",
                                                color: "gray"
                                              }
                                            },
                                            [
                                              _c(
                                                "table",
                                                { staticClass: "grid_table" },
                                                [
                                                  _vm._m(1, true),
                                                  _vm._v(" "),
                                                  _c(
                                                    "tbody",
                                                    {
                                                      staticClass: "text_center"
                                                    },
                                                    [
                                                      _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticStyle: {
                                                              "text-align":
                                                                "left",
                                                              color: "gray"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Copyright© 1995-" +
                                                                _vm._s(
                                                                  _vm
                                                                    .$moment(
                                                                      item.MODF_DT
                                                                    )
                                                                    .format(
                                                                      "YYYY"
                                                                    )
                                                                ) +
                                                                " SAMSUNG. All rights reserved."
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._m(2, true)
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                0 < item.part.rowCount
                                  ? _c("div", { staticClass: "tab_wrap" }, [
                                      _c(
                                        "ul",
                                        {
                                          staticClass: "tab_menu_02 tab_menus"
                                        },
                                        [
                                          _c("li", { staticClass: "on" }, [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "javascript:" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "FIELD.KNOWLEDGE.PARTSLISTS"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "tab_contents" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "tab_cont" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "grid_wrap" },
                                                [
                                                  _c(
                                                    "table",
                                                    {
                                                      staticClass: "grid_table"
                                                    },
                                                    [
                                                      _vm._m(3, true),
                                                      _vm._v(" "),
                                                      _c("thead", [
                                                        _c(
                                                          "tr",
                                                          {
                                                            staticClass:
                                                              "text_center"
                                                          },
                                                          [
                                                            _c("th", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "FIELD.GLOBAL.PARTS.CODE"
                                                                  )
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("th", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "FIELD.GLOBAL.PARTS.TYPE"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "tbody",
                                                        {
                                                          staticClass:
                                                            "text_center"
                                                        },
                                                        _vm._l(
                                                          item.part.rowData,
                                                          function(part, idx) {
                                                            return _c(
                                                              "tr",
                                                              {
                                                                key:
                                                                  part.PARTS_SEQ +
                                                                  idx
                                                              },
                                                              [
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      part.PARTS_CODE
                                                                    )
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      part.PARTS_TYPE
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "attachment_wrap" }, [
                                  _c(
                                    "ul",
                                    _vm._l(item.attach.rowData, function(
                                      file,
                                      idx
                                    ) {
                                      return _c(
                                        "li",
                                        { key: file.ATTCH_FILE_SEQ + idx },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: _vm.getDownloadUrl(
                                                  file.ENC_ATTCH_FILE_SEQ,
                                                  file.ENC_TOKEN
                                                ),
                                                download: "true",
                                                target: "_blank"
                                              }
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "ico_attach"
                                              }),
                                              _vm._v(
                                                "\n                                                        " +
                                                  _vm._s(file.FILE_NM) +
                                                  "\n                                                    "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ])
                              ])
                            ])
                          ]
                        )
                      }),
                      0
                    )
              ])
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "250" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "250" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "50%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "50%" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticStyle: { "text-align": "right", color: "gray" } }, [
      _vm._v(
        " Distribution, transmission, or infringement of any content or data from this"
      ),
      _c("br"),
      _vm._v(
        "   document without Samsung’s written authorization is strictly prohibited      "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "50%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "50%" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f713423", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f713423","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/eur/user/RequestContents.vue
// module id = nKLY
// module chunks = 0